// ============================================================
//  WILLIANS 30 — MAIN JS
// ============================================================

import AOS from 'aos';

// --- AOS INIT ---
AOS.init({
  duration: 800,
  easing: 'ease-out-quart',
  once: true,
  offset: 60,
});

// ============================================================
//  COUNTDOWN — até 26/12/2026 às 20:00
// ============================================================
function updateCountdown() {
  const eventDate = new Date('2026-12-26T20:00:00');
  const now = new Date();
  const diff = eventDate - now;

  if (diff <= 0) {
    document.getElementById('days').textContent = '00';
    document.getElementById('hours').textContent = '00';
    document.getElementById('minutes').textContent = '00';
    document.getElementById('seconds').textContent = '00';
    return;
  }

  const days    = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours   = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((diff % (1000 * 60)) / 1000);

  function setNum(id, val) {
    const el = document.getElementById(id);
    const padded = String(val).padStart(2, '0');
    if (el.textContent !== padded) {
      el.textContent = padded;
      el.classList.remove('num-flip');
      void el.offsetWidth; // reflow
      el.classList.add('num-flip');
    }
  }

  setNum('days', days);
  setNum('hours', hours);
  setNum('minutes', minutes);
  setNum('seconds', seconds);
}

updateCountdown();
setInterval(updateCountdown, 1000);

// ============================================================
//  PARTICLES
// ============================================================
function createParticles() {
  const container = document.getElementById('particles');
  if (!container) return;

  const count = 30;
  for (let i = 0; i < count; i++) {
    const p = document.createElement('div');
    p.classList.add('particle');
    const size = Math.random() * 4 + 2;
    p.style.cssText = `
      width: ${size}px;
      height: ${size}px;
      left: ${Math.random() * 100}%;
      top: ${Math.random() * 100}%;
      --dur: ${(Math.random() * 4 + 3).toFixed(1)}s;
      --delay: ${(Math.random() * 5).toFixed(1)}s;
      opacity: 0;
    `;
    container.appendChild(p);
  }
}

createParticles();

// ============================================================
//  WHATSAPP RSVP
// ============================================================
document.getElementById('btnWhatsApp').addEventListener('click', () => {
  const nome       = document.getElementById('nome').value.trim();
  const whatsapp   = document.getElementById('whatsapp').value.trim();
  const convidados = document.getElementById('convidados');
  const restricao  = document.getElementById('restricao').value.trim();
  const mensagem   = document.getElementById('mensagem').value.trim();

  if (!nome || !whatsapp) {
    shakeInput(!nome ? 'nome' : 'whatsapp');
    return;
  }

  const acompText = convidados.options[convidados.selectedIndex].text;

  let msg = `🥂 *Confirmação de Presença — Festa 30 Anos do Willians!*\n\n`;
  msg += `👤 *Nome:* ${nome}\n`;
  msg += `📱 *WhatsApp:* ${whatsapp}\n`;
  msg += `👥 *Acompanhantes:* ${acompText}\n`;
  if (restricao) msg += `🍽️ *Restrição alimentar:* ${restricao}\n`;
  if (mensagem)  msg += `💌 *Mensagem:* ${mensagem}\n`;
  msg += `\n📅 *Data do evento:* 26/12/2026 às 20h00`;

  // Troque pelo número do WhatsApp real do aniversariante (formato: 55DDD9XXXXXXXX)
  const numero = '5511999999999';
  const url = `https://wa.me/${numero}?text=${encodeURIComponent(msg)}`;

  window.open(url, '_blank');
});

function shakeInput(id) {
  const el = document.getElementById(id);
  el.style.animation = 'none';
  el.style.borderColor = '#e05555';
  void el.offsetWidth;
  el.style.animation = 'shake 0.4s ease';
  setTimeout(() => {
    el.style.borderColor = '';
    el.style.animation = '';
  }, 600);
}

// Inject shake keyframe
const style = document.createElement('style');
style.textContent = `
  @keyframes shake {
    0%, 100% { transform: translateX(0); }
    25% { transform: translateX(-8px); }
    75% { transform: translateX(8px); }
  }
`;
document.head.appendChild(style);
